import { OBSIDIAN, OBSIDIAN_BODY_FONT, OBSIDIAN_DISPLAY_FONT } from '../../../constants/obsidianDashboardTheme';

export const LOYALTY_GOLD = OBSIDIAN.primary;
export const LOYALTY_GOLD_DIM = OBSIDIAN.primaryDim;
export const LOYALTY_MINT = OBSIDIAN.secondary;
export const LOYALTY_SURFACE = OBSIDIAN.background;
export const LOYALTY_SURFACE_LOW = OBSIDIAN.surfaceContainerLow;
export const LOYALTY_SURFACE_CONTAINER = OBSIDIAN.surfaceContainer;
export const LOYALTY_SURFACE_HIGH = OBSIDIAN.surfaceContainerHigh;
export const LOYALTY_SURFACE_HIGHEST = OBSIDIAN.surfaceContainerHighest;
export const LOYALTY_ON_VARIANT = OBSIDIAN.onSurfaceVariant;

/** Template fonts: Plus Jakarta Sans (display/headline), Manrope (body/label). */
export const LOYALTY_DISPLAY_FONT = OBSIDIAN_DISPLAY_FONT;
export const LOYALTY_BODY_FONT = OBSIDIAN_BODY_FONT;

/** Applied on loyalty page shell — sets Manrope as default, Plus Jakarta on buttons. */
export const loyaltyPageFontSx = {
    fontFamily: LOYALTY_BODY_FONT,
    color: OBSIDIAN.onSurface,
    '& .MuiTypography-root': { fontFamily: LOYALTY_BODY_FONT },
    '& .MuiButton-root': { fontFamily: LOYALTY_DISPLAY_FONT },
    '& .MuiTableCell-root': { fontFamily: LOYALTY_BODY_FONT },
    '& .MuiInputBase-root': { fontFamily: LOYALTY_BODY_FONT },
    '& .MuiDialogTitle-root': { fontFamily: LOYALTY_DISPLAY_FONT },
} as const;

export const loyaltyPageTitleSx = {
    fontFamily: LOYALTY_DISPLAY_FONT,
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1.15,
} as const;

export const loyaltyHeroTitleSx = {
    ...loyaltyPageTitleSx,
    fontSize: { xs: 32, md: 44 },
    fontWeight: 900,
    letterSpacing: '-0.03em',
} as const;

export const loyaltySectionTitleSx = {
    fontFamily: LOYALTY_DISPLAY_FONT,
    fontWeight: 800,
    letterSpacing: '-0.02em',
} as const;

export const loyaltyStatValueSx = {
    fontFamily: LOYALTY_DISPLAY_FONT,
    fontWeight: 900,
    letterSpacing: '-0.03em',
    lineHeight: 1.1,
} as const;

export const loyaltyLabelTextSx = {
    fontFamily: LOYALTY_BODY_FONT,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.12em',
    textTransform: 'uppercase' as const,
    color: LOYALTY_ON_VARIANT,
} as const;

export const loyaltyBodyTextSx = {
    fontFamily: LOYALTY_BODY_FONT,
    fontSize: 14,
    color: LOYALTY_ON_VARIANT,
} as const;

export const loyaltyHeadlineSx = {
    fontFamily: LOYALTY_DISPLAY_FONT,
    fontWeight: 700,
} as const;

export const loyaltyCardSx = {
    bgcolor: LOYALTY_SURFACE_LOW,
    borderRadius: '12px',
    border: '1px solid rgba(255,201,101,0.05)',
    transition: 'background-color 0.3s, transform 0.3s',
    '&:hover': { bgcolor: LOYALTY_SURFACE_CONTAINER },
} as const;

export const loyaltyGoldButtonSx = {
    background: `linear-gradient(135deg, ${LOYALTY_GOLD} 0%, #feb700 100%)`,
    color: '#392700',
    fontFamily: LOYALTY_DISPLAY_FONT,
    fontWeight: 800,
    borderRadius: '999px',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.08em',
    px: 4,
    py: 1.5,
    boxShadow: '0 10px 30px rgba(254,183,0,0.15)',
    '&:hover': {
        background: `linear-gradient(135deg, ${LOYALTY_GOLD_DIM} 0%, #feb700 100%)`,
        transform: 'scale(1.02)',
    },
};
